if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.zoomButton = this.querySelector('[data-zoom-label]');
      this.zoomButton?.addEventListener('click', () => {
        this.setZoomed(!this.classList.contains('is-zoomed'));
      });
      this.addEventListener('click', (event) => {
        if (!this.classList.contains('product-media-modal--silver-bullet')) return;
        if (!event.target.closest('.product-featured-media')) return;
        this.setZoomed(!this.classList.contains('is-zoomed'));
      });
    }

    hide() {
      this.setZoomed(false);
      super.hide();
    }

    show(opener) {
      this.setZoomed(false);
      super.show(opener);
      this.showActiveMedia();
    }

    setZoomed(zoomed) {
      if (!this.classList.contains('product-media-modal--silver-bullet')) return;
      this.classList.toggle('is-zoomed', zoomed);
      if (this.zoomButton) {
        const label = zoomed ? this.zoomButton.dataset.fitLabel : this.zoomButton.dataset.zoomLabel;
        this.zoomButton.setAttribute('aria-label', label);
        this.zoomButton.setAttribute('aria-pressed', String(zoomed));
        const labelElement = this.zoomButton.querySelector('span');
        if (labelElement) labelElement.textContent = label;
      }
      if (zoomed) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const viewport = this.querySelector('.product-single__media.active');
            if (!viewport) return;
            viewport.scrollLeft = (viewport.scrollWidth - viewport.clientWidth) / 2;
            viewport.scrollTop = (viewport.scrollHeight - viewport.clientHeight) / 2;
          });
        });
      }
    }

    showActiveMedia() {
      this.querySelectorAll('.product-single__media-wrapper.active').forEach((element) => {
        element.classList.remove('active');
      });
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      );
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.closest('.product-single__media-wrapper')?.classList.add('active');

      const container = this.querySelector('[role="document"]');
      if (this.classList.contains('product-media-modal--silver-bullet')) {
        container.scrollTop = 0;
        container.scrollLeft = 0;
      } else {
        activeMedia.scrollIntoView();
        const mediaWidth = activeMedia.scrollWidth || activeMedia.offsetWidth || activeMedia.clientWidth;
        container.scrollLeft = (mediaWidth - container.clientWidth) / 2;
      }

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-vimeo')
      )
        activeMedia.loadContent();
    }
  });
}

if (!customElements.get('sb-image-modal-opener')) {
  customElements.define('sb-image-modal-opener', class SilverBulletImageModalOpener extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.pointerStart = null;
      this.pointerMoved = false;
      this.button.addEventListener('pointerdown', (event) => {
        this.pointerStart = { x: event.clientX, y: event.clientY };
        this.pointerMoved = false;
      });
      this.button.addEventListener('pointermove', (event) => {
        if (!this.pointerStart) return;
        if (
          Math.abs(event.clientX - this.pointerStart.x) > 8 ||
          Math.abs(event.clientY - this.pointerStart.y) > 8
        ) {
          this.pointerMoved = true;
        }
      });
      this.button.addEventListener('pointercancel', () => {
        this.pointerStart = null;
        this.pointerMoved = true;
      });
      this.button.addEventListener('click', (event) => {
        this.pointerStart = null;
        if (this.pointerMoved) {
          event.preventDefault();
          this.pointerMoved = false;
          return;
        }
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(this.button);
      });
    }
  });
}
